import React, { FC } from 'react';
import { isTokenExpired } from '@blocs.auth';

type Props = {
  token: string;
  actualRouterPathName: string;
  redirectToLoginPage: () => void;
  loggedOutRoutes?: Array<string>;
};

const LoginPageRedirection: FC<Props> = ({
  token,
  actualRouterPathName,
  redirectToLoginPage,
  loggedOutRoutes = ['/forgot-password', '/reset-password', '/create-password'],
  children,
}) => {
  if (typeof window === 'undefined') {
    return null;
  }

  const isPathALoggedOutRoute = !!loggedOutRoutes.find((loggedOutRoute) => loggedOutRoute === actualRouterPathName);

  if (!isPathALoggedOutRoute && isTokenExpired(token)) {
    redirectToLoginPage();

    return <></>;
  }

  return <>{children}</>;
};

export default LoginPageRedirection;
